<canvas [id]="'chart-' + chartId" class="bar-chart"></canvas>
<div [id]="'tooltip-' + chartId" class="custom-tooltip"></div>
